import { Text, View, Pressable, StyleSheet, ActivityIndicator } from 'react-native';
import React, { useState } from 'react';
import Constants from './../constants';
import { XCircleIcon } from '@heroicons/react/solid';

export enum Theme {
  PRIMARY = "PRIMARY",
  PRIMARY_NEUTRAL = "PRIMARY_NEUTRAL",
  PRIMARY_MEDIUM = "PRIMARY_MEDIUM",
  ACCENT = "ACCENT",
  WARNING = "WARNING",
  SUCCESS = "SUCCESS",
  DANGER = "DANGER",
  DANGER_MEDIUM = "DANGER_MEDIUM",
  LINK = "LINK",
  LINK_DANGER = "LINK_DANGER",
  LINK_PRIMARY = "LINK_PRIMARY",
  LINK_PRIMARY_MEDIUM = "LINK_PRIMARY_MEDIUM",
  LINK_WARNING = "LINK_WARNING",
}

export enum Hoverable {
  BUTTON = "BUTTON",
  DELETE = "DELETE"
}

export type IconTypes = "users" | "user-circle" | "dashboard" | "eye" | "image" | "clone" | "trash" | "message" | "campaignPlus" | "campaignMinus" | "usersPlus" | "usersMinus" | "download" | "plus" | "video" | "feather" | "calendar" | "bars" | "person" | "bell" | "cancel" | "archive" | "clock" | "library" | "share" | "tag" | "info";

export default function Icon({ name, onClick, width, height, raw = false, style = {}, color = "#959595", colorHover = "#AAA" }: { name: IconTypes, onClick?: () => void, raw?: boolean, width?: number, height?: number, style?: object, color?: string, colorHover?: string }): JSX.Element | null {
  const [hovering, setHovering] = useState<boolean>();

  const onHover = () => {
    if (onClick !== undefined) {
      setHovering(true);
    }
  }

  const onHoverOut = () => {
    setHovering(undefined);
  }


  const renderIcon = (currentColor: string, currentStyle: object = {}) => {
    if (name === "users") {
      return (
        <svg style={currentStyle} height={height === undefined ? "22" : height} width={width === undefined ? "28" : width} viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.375 11.275C15.042 10.6977 15.5769 9.98361 15.9436 9.18128C16.3102 8.37895 16.5 7.50714 16.5 6.625C16.5 4.9674 15.8415 3.37769 14.6694 2.20558C13.4973 1.03348 11.9076 0.375 10.25 0.375C8.5924 0.375 7.00269 1.03348 5.83058 2.20558C4.65848 3.37769 4 4.9674 4 6.625C3.99999 7.50714 4.18975 8.37895 4.55641 9.18128C4.92306 9.98361 5.45803 10.6977 6.125 11.275C4.37517 12.0674 2.89058 13.3469 1.84873 14.9607C0.806869 16.5744 0.25184 18.4541 0.25 20.375C0.25 20.7065 0.381696 21.0245 0.616116 21.2589C0.850537 21.4933 1.16848 21.625 1.5 21.625C1.83152 21.625 2.14946 21.4933 2.38388 21.2589C2.6183 21.0245 2.75 20.7065 2.75 20.375C2.75 18.3859 3.54018 16.4782 4.9467 15.0717C6.35322 13.6652 8.26088 12.875 10.25 12.875C12.2391 12.875 14.1468 13.6652 15.5533 15.0717C16.9598 16.4782 17.75 18.3859 17.75 20.375C17.75 20.7065 17.8817 21.0245 18.1161 21.2589C18.3505 21.4933 18.6685 21.625 19 21.625C19.3315 21.625 19.6495 21.4933 19.8839 21.2589C20.1183 21.0245 20.25 20.7065 20.25 20.375C20.2482 18.4541 19.6931 16.5744 18.6513 14.9607C17.6094 13.3469 16.1248 12.0674 14.375 11.275ZM10.25 10.375C9.50832 10.375 8.7833 10.1551 8.16661 9.74301C7.54993 9.33095 7.06928 8.74529 6.78545 8.06006C6.50162 7.37484 6.42736 6.62084 6.57206 5.89341C6.71675 5.16598 7.0739 4.4978 7.59835 3.97335C8.1228 3.4489 8.79098 3.09175 9.51841 2.94706C10.2458 2.80236 10.9998 2.87662 11.6851 3.16045C12.3703 3.44428 12.956 3.92493 13.368 4.54161C13.7801 5.1583 14 5.88332 14 6.625C14 7.61956 13.6049 8.57339 12.9017 9.27665C12.1984 9.97991 11.2446 10.375 10.25 10.375ZM22.425 10.775C23.225 9.87416 23.7475 8.76132 23.9298 7.57042C24.112 6.37953 23.9462 5.16134 23.4522 4.0625C22.9583 2.96366 22.1572 2.03099 21.1456 1.37678C20.1339 0.722562 18.9548 0.374678 17.75 0.375C17.4185 0.375 17.1005 0.506696 16.8661 0.741117C16.6317 0.975537 16.5 1.29348 16.5 1.625C16.5 1.95652 16.6317 2.27446 16.8661 2.50888C17.1005 2.7433 17.4185 2.875 17.75 2.875C18.7446 2.875 19.6984 3.27009 20.4017 3.97335C21.1049 4.67661 21.5 5.63044 21.5 6.625C21.4982 7.28155 21.3241 7.92613 20.9951 8.49428C20.666 9.06242 20.1936 9.53423 19.625 9.8625C19.4397 9.9694 19.2849 10.1221 19.1755 10.3059C19.066 10.4898 19.0056 10.6986 19 10.9125C18.9948 11.1247 19.0437 11.3347 19.1421 11.5228C19.2405 11.7109 19.3852 11.8708 19.5625 11.9875L20.05 12.3125L20.2125 12.4C21.7192 13.1146 22.9904 14.245 23.8762 15.6579C24.7621 17.0708 25.2257 18.7074 25.2125 20.375C25.2125 20.7065 25.3442 21.0245 25.5786 21.2589C25.813 21.4933 26.131 21.625 26.4625 21.625C26.794 21.625 27.112 21.4933 27.3464 21.2589C27.5808 21.0245 27.7125 20.7065 27.7125 20.375C27.7227 18.4568 27.2423 16.5678 26.3168 14.8876C25.3914 13.2073 24.0517 11.7916 22.425 10.775Z" fill={currentColor} />
        </svg>
      )
    } else if (name === "dashboard") {
      return (
        <svg style={currentStyle} height={height === undefined ? "25" : height} width={width === undefined ? "25" : width} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.2273 4.54545C10.0025 4.54545 9.78282 4.6121 9.59594 4.73697C9.40907 4.86183 9.26342 5.03931 9.17741 5.24695C9.0914 5.45459 9.0689 5.68308 9.11274 5.90351C9.15659 6.12395 9.26482 6.32643 9.42374 6.48535C9.58267 6.64427 9.78515 6.7525 10.0056 6.79635C10.226 6.84019 10.4545 6.81769 10.6621 6.73168C10.8698 6.64567 11.0473 6.50002 11.1721 6.31315C11.297 6.12627 11.3636 5.90657 11.3636 5.68182C11.3636 5.38044 11.2439 5.0914 11.0308 4.87829C10.8177 4.66518 10.5287 4.54545 10.2273 4.54545ZM5.68182 4.54545C5.45707 4.54545 5.23736 4.6121 5.05049 4.73697C4.86361 4.86183 4.71796 5.03931 4.63196 5.24695C4.54595 5.45459 4.52344 5.68308 4.56729 5.90351C4.61114 6.12395 4.71936 6.32643 4.87829 6.48535C5.03721 6.64427 5.23969 6.7525 5.46012 6.79635C5.68056 6.84019 5.90904 6.81769 6.11669 6.73168C6.32433 6.64567 6.50181 6.50002 6.62667 6.31315C6.75154 6.12627 6.81818 5.90657 6.81818 5.68182C6.81818 5.38044 6.69846 5.0914 6.48535 4.87829C6.27224 4.66518 5.9832 4.54545 5.68182 4.54545ZM14.7727 4.54545C14.548 4.54545 14.3283 4.6121 14.1414 4.73697C13.9545 4.86183 13.8089 5.03931 13.7229 5.24695C13.6369 5.45459 13.6144 5.68308 13.6582 5.90351C13.702 6.12395 13.8103 6.32643 13.9692 6.48535C14.1281 6.64427 14.3306 6.7525 14.551 6.79635C14.7715 6.84019 15 6.81769 15.2076 6.73168C15.4152 6.64567 15.5927 6.50002 15.7176 6.31315C15.8424 6.12627 15.9091 5.90657 15.9091 5.68182C15.9091 5.38044 15.7894 5.0914 15.5763 4.87829C15.3631 4.66518 15.0741 4.54545 14.7727 4.54545ZM21.5909 0H3.40909C2.50494 0 1.63783 0.359171 0.9985 0.9985C0.359171 1.63783 0 2.50494 0 3.40909V21.5909C0 22.4951 0.359171 23.3622 0.9985 24.0015C1.63783 24.6408 2.50494 25 3.40909 25H21.5909C22.4951 25 23.3622 24.6408 24.0015 24.0015C24.6408 23.3622 25 22.4951 25 21.5909V3.40909C25 2.50494 24.6408 1.63783 24.0015 0.9985C23.3622 0.359171 22.4951 0 21.5909 0ZM22.7273 21.5909C22.7273 21.8923 22.6075 22.1813 22.3944 22.3944C22.1813 22.6075 21.8923 22.7273 21.5909 22.7273H3.40909C3.10771 22.7273 2.81867 22.6075 2.60556 22.3944C2.39245 22.1813 2.27273 21.8923 2.27273 21.5909V11.3636H22.7273V21.5909ZM22.7273 9.09091H2.27273V3.40909C2.27273 3.10771 2.39245 2.81867 2.60556 2.60556C2.81867 2.39245 3.10771 2.27273 3.40909 2.27273H21.5909C21.8923 2.27273 22.1813 2.39245 22.3944 2.60556C22.6075 2.81867 22.7273 3.10771 22.7273 3.40909V9.09091Z" fill={currentColor} />
        </svg>
      )
    } else if (name === "eye") {
      return (
        <svg style={currentStyle} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 24" height={height === undefined ? "24" : height} width={width === undefined ? "30" : width} fill="none">
          <path
            id="path1429"
            strokeLinejoin="round"
            strokeLinecap="round"
            strokeWidth="2.5"
            stroke={currentColor}
            d="M1.25 12C1.25 12 6.25 2 15 2C23.75 2 28.75 12 28.75 12C28.75 12 23.75 22 15 22C6.25 22 1.25 12 1.25 12Z" />
          <path
            d="m 15,15.75 c 2.07107,0 3.75,-1.67893 3.75,-3.75 0,-2.07107 -1.67893,-3.75 -3.75,-3.75 -2.07107,0 -3.75,1.67893 -3.75,3.75 0,2.07107 1.67893,3.75 3.75,3.75 z"
            stroke={currentColor}
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            id="path833" />
        </svg>
      )
    } else if (name === "image") {
      return (
        <svg
          style={currentStyle}
          xmlns="http://www.w3.org/2000/svg"
          id="svg2060"
          version="1.1"
          fill="none"
          viewBox="0 0 26 26"
          height={height === undefined ? "26" : height}
          width={width === undefined ? "26" : width}>
          <path
            id="path2058"
            strokeLinejoin="round"
            strokeLinecap="round"
            strokeWidth="2.16228"
            stroke={currentColor}
            d="M21.7505 1.75H4.25049C2.86978 1.75 1.75049 2.86929 1.75049 4.25V21.75C1.75049 23.1307 2.86978 24.25 4.25049 24.25H21.7505C23.1312 24.25 24.2505 23.1307 24.2505 21.75V4.25C24.2505 2.86929 23.1312 1.75 21.7505 1.75Z" />
          <path
            d="m 24.168331,16.325069 -6.25,-6.25 -13.7500001,13.74996"
            stroke={currentColor}
            strokeWidth="2.16228"
            strokeLinecap="round"
            strokeLinejoin="round"
            id="path3200" />
          <path
            d="m 8.4602837,10.024937 c 1.03553,0 1.8750003,-0.8394601 1.8750003,-1.8750001 0,-1.03553 -0.8394703,-1.875 -1.8750003,-1.875 -1.03553,0 -1.875,0.83947 -1.875,1.875 0,1.03554 0.83947,1.8750001 1.875,1.8750001 z"
            stroke={currentColor}
            strokeWidth="2.16228"
            strokeLinecap="round"
            strokeLinejoin="round"
            id="path2629" />
        </svg>
      )
    } else if (name === "trash") {
      return (
        <svg
          style={currentStyle}
          xmlns="http://www.w3.org/2000/svg"
          id="svg4392"
          version="1.1"
          fill="none"
          viewBox="0 0 24.662279 27.162281"
          height={height === undefined ? "27" : height}
          width={width === undefined ? "25" : width}>
          <path
            id="path4390"
            strokeLinejoin="round"
            strokeLinecap="round"
            strokeWidth="2.16228"
            stroke={currentColor}
            d="m 7.3311399,6.08114 v -2.5 c 0,-0.66304 0.26339,-1.29893 0.73223,-1.76777 0.46884,-0.46884 1.10473,-0.73223 1.76777,-0.73223 H 14.83114 c 0.663,0 1.2989,0.26339 1.7678,0.73223 0.4688,0.46884 0.7322,1.10473 0.7322,1.76777 v 2.5 m 3.75,0 v 17.5 c 0,0.663 -0.2634,1.2989 -0.7322,1.7678 -0.4689,0.4688 -1.1048,0.7322 -1.7678,0.7322 H 6.0811399 c -0.66304,0 -1.29893,-0.2634 -1.76777,-0.7322 -0.46884,-0.4689 -0.73223,-1.1048 -0.73223,-1.7678 v -17.5 z" />
          <path
            d="M 1.08114,6.1030703 H 3.5811401 23.58114"
            stroke={currentColor}
            strokeWidth="2.16228"
            strokeLinecap="round"
            strokeLinejoin="round"
            id="path3819" />
          <path
            d="m 9.259698,11.821889 v 7.5"
            stroke={currentColor}
            strokeWidth="2.16228"
            strokeLinecap="round"
            strokeLinejoin="round"
            id="path4961" />
          <path
            d="m 15.231946,11.821889 v 7.5"
            stroke={currentColor}
            strokeWidth="2.16228"
            strokeLinecap="round"
            strokeLinejoin="round"
            id="path5532" />
        </svg>
      )
    } else if (name === "clone") {
      return (
        <svg
          style={currentStyle}
          xmlns="http://www.w3.org/2000/svg"
          id="svg6739"
          version="1.1"
          fill="none"
          viewBox="0 0 26.790644 26.683445"
          height={height === undefined ? "28" : height}
          width={width === undefined ? "26" : width}>
          <path
            id="path6737"
            strokeLinejoin="round"
            strokeLinecap="round"
            strokeWidth="2.16228"
            stroke={currentColor}
            d="m 23.209503,9.3523052 h -11.25 c -1.38071,0 -2.5,1.1192898 -2.5,2.4999998 v 11.25 c 0,1.3807 1.11929,2.5 2.5,2.5 h 11.25 c 1.3807,0 2.5,-1.1193 2.5,-2.5 v -11.25 c 0,-1.38071 -1.1193,-2.4999998 -2.5,-2.4999998 z" />
          <path
            d="m 4.83114,17.33114 h -1.25 c -0.66304,0 -1.29893,-0.2634 -1.76777,-0.7322 -0.46884,-0.4689 -0.73223,-1.1048 -0.73223,-1.7678 v -11.25 C 1.08114,2.9181 1.34453,2.28221 1.81337,1.81337 2.28221,1.34453 2.9181,1.08114 3.58114,1.08114 h 11.25 c 0.663,0 1.298901,0.26339 1.767801,0.73223 0.4688,0.46884 0.7322,1.10473 0.7322,1.76777 v 1.25"
            stroke={currentColor}
            strokeWidth="2.16228"
            strokeLinecap="round"
            strokeLinejoin="round"
            id="path6166" />
        </svg>
      )
    } else if (name === "message") {
      return (
        <svg style={currentStyle} height={height === undefined ? "20" : height} width={width === undefined ? "20" : width} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.0005 9H5.00049C4.73527 9 4.48092 9.10536 4.29338 9.29289C4.10585 9.48043 4.00049 9.73478 4.00049 10C4.00049 10.2652 4.10585 10.5196 4.29338 10.7071C4.48092 10.8946 4.73527 11 5.00049 11H11.0005C11.2657 11 11.5201 10.8946 11.7076 10.7071C11.8951 10.5196 12.0005 10.2652 12.0005 10C12.0005 9.73478 11.8951 9.48043 11.7076 9.29289C11.5201 9.10536 11.2657 9 11.0005 9ZM15.0005 5H5.00049C4.73527 5 4.48092 5.10536 4.29338 5.29289C4.10585 5.48043 4.00049 5.73478 4.00049 6C4.00049 6.26522 4.10585 6.51957 4.29338 6.70711C4.48092 6.89464 4.73527 7 5.00049 7H15.0005C15.2657 7 15.5201 6.89464 15.7076 6.70711C15.8951 6.51957 16.0005 6.26522 16.0005 6C16.0005 5.73478 15.8951 5.48043 15.7076 5.29289C15.5201 5.10536 15.2657 5 15.0005 5ZM17.0005 0H3.00049C2.20484 0 1.44178 0.316071 0.879168 0.87868C0.316559 1.44129 0.000488281 2.20435 0.000488281 3V13C0.000488281 13.7956 0.316559 14.5587 0.879168 15.1213C1.44178 15.6839 2.20484 16 3.00049 16H14.5905L18.2905 19.71C18.3839 19.8027 18.4947 19.876 18.6166 19.9258C18.7384 19.9755 18.8689 20.0008 19.0005 20C19.1317 20.0034 19.2618 19.976 19.3805 19.92C19.5631 19.845 19.7194 19.7176 19.8298 19.5539C19.9401 19.3901 19.9995 19.1974 20.0005 19V3C20.0005 2.20435 19.6844 1.44129 19.1218 0.87868C18.5592 0.316071 17.7961 0 17.0005 0ZM18.0005 16.59L15.7105 14.29C15.617 14.1973 15.5062 14.124 15.3844 14.0742C15.2626 14.0245 15.1321 13.9992 15.0005 14H3.00049C2.73527 14 2.48092 13.8946 2.29338 13.7071C2.10585 13.5196 2.00049 13.2652 2.00049 13V3C2.00049 2.73478 2.10585 2.48043 2.29338 2.29289C2.48092 2.10536 2.73527 2 3.00049 2H17.0005C17.2657 2 17.5201 2.10536 17.7076 2.29289C17.8951 2.48043 18.0005 2.73478 18.0005 3V16.59Z" fill={currentColor} />
        </svg>
      )
    } else if (name === "campaignPlus") {
      return (
        <svg
          style={currentStyle}
          xmlns="http://www.w3.org/2000/svg"
          id="svg835"
          version="1.1"
          fill="none"
          viewBox="0 0 23.554144 17.7778"
          height={height === undefined ? "18" : height}
          width={width === undefined ? "24" : width}>
          <path
            id="path833"
            fill={currentColor}
            d="M 15.1111,1.4969877e-7 C 14.9944,-6.64544e-5 14.8787,0.0228798 14.7709,0.0675271 14.663,0.112174 14.565,0.177647 14.4824,0.260201 14.3999,0.342755 14.3344,0.440772 14.2897,0.548647 14.2451,0.656522 14.2222,0.77214 14.2222,0.888889 V 1.45486 C 13.4725,2.38438 12.525,3.13503 11.4487,3.65219 10.3723,4.16936 9.19415,4.44001 8,4.44444 H 2.66667 C 1.95966,4.44522 1.28183,4.72642 0.781901,5.22635 0.281971,5.72628 7.71729e-4,6.4041 0,7.11111 V 8.88889 C 7.71729e-4,9.5959 0.281971,10.2737 0.781901,10.7737 1.28183,11.2736 1.95966,11.5548 2.66667,11.5556 H 3.0967 L 0.960942,16.539 c -0.05804,0.1352 -0.081604,0.2827 -0.068576,0.4292 0.013028,0.1465 0.06224,0.2875 0.143214,0.4103 0.08098,0.1228 0.19119,0.2236 0.32073,0.2933 0.12954,0.0697 0.27437,0.1061 0.42147,0.106 h 3.55555 c 0.17401,10e-5 0.3442,-0.051 0.48943,-0.1468 0.14523,-0.0958 0.25909,-0.2323 0.32742,-0.3923 l 2.42111,-5.6494 c 1.0939,0.0804 2.15971,0.3841 3.13171,0.8924 0.9719,0.5084 1.8293,1.2106 2.5192,2.0633 v 0.5661 c 0,0.2358 0.0937,0.4619 0.2604,0.6286 C 14.6493,15.9063 14.8754,16 15.1111,16 15.3469,16 15.5729,15.9063 15.7396,15.7397 15.9063,15.573 16,15.3469 16,15.1111 V 0.888889 C 16.0001,0.772139 15.9771,0.656521 15.9325,0.548646 15.8878,0.44077 15.8224,0.342753 15.7398,0.260199 15.6572,0.177644 15.5592,0.112172 15.4514,0.0675247 15.3435,0.0228779 15.2279,-6.76241e-5 15.1111,1.4969877e-7 Z M 2.66667,9.77778 C 2.43097,9.77762 2.20497,9.68392 2.0383,9.51725 1.87164,9.35059 1.77794,9.12459 1.77778,8.88889 V 7.11111 C 1.77794,6.87541 1.87164,6.64941 2.0383,6.48275 2.20497,6.31609 2.43097,6.22238 2.66667,6.22222 H 3.55555 V 9.77778 Z M 4.7474,16 H 3.12587 l 1.90451,-4.4444 h 1.62153 z m 9.4748,-3.9806 C 12.4696,10.5755 10.2708,9.78336 8,9.77773 H 5.33333 V 6.22218 H 8 C 10.2709,6.21637 12.4696,5.4241 14.2222,3.9801 Z" />
          <path
            d="m 21.554143,7.4983477 h 1 c 0.26522,0 0.51957,0.10536 0.70711,0.29289 0.18754,0.18754 0.29289,0.44189 0.29289,0.70711 0,0.2652204 -0.10535,0.5195704 -0.29289,0.7071104 -0.18754,0.18753 -0.44189,0.29289 -0.70711,0.29289 h -1 v 0.9999999 c 0,0.26522 -0.10535,0.51957 -0.29289,0.70711 -0.18754,0.18753 -0.44189,0.29289 -0.70711,0.29289 -0.26522,0 -0.51957,-0.10536 -0.70711,-0.29289 -0.18753,-0.18754 -0.29289,-0.44189 -0.29289,-0.70711 V 9.4983481 h -1 c -0.265216,0 -0.519571,-0.10536 -0.707107,-0.29289 -0.187537,-0.18754 -0.292893,-0.44189 -0.292893,-0.7071104 0,-0.26522 0.105356,-0.51957 0.292893,-0.70711 0.187536,-0.18753 0.441891,-0.29289 0.707107,-0.29289 h 1 v -1 c 0,-0.265217 0.10536,-0.51957 0.29289,-0.707107 0.18754,-0.187536 0.44189,-0.292893 0.70711,-0.292893 0.26522,0 0.51957,0.105357 0.70711,0.292893 0.18754,0.187537 0.29289,0.44189 0.29289,0.707107 z"
            fill={currentColor}
            id="path843" />
        </svg>

      )
    } else if (name === "campaignMinus") {
      return (
        <svg
          style={currentStyle}
          xmlns="http://www.w3.org/2000/svg"
          height={height === undefined ? "18" : height}
          width={width === undefined ? "24" : width}
          viewBox="0 0 23.554144 17.7778"
          fill="none"
          version="1.1"
          id="svg835">
          <path
            d="M 15.1111,1.4969877e-7 C 14.9944,-6.64544e-5 14.8787,0.0228798 14.7709,0.0675271 14.663,0.112174 14.565,0.177647 14.4824,0.260201 14.3999,0.342755 14.3344,0.440772 14.2897,0.548647 14.2451,0.656522 14.2222,0.77214 14.2222,0.888889 V 1.45486 C 13.4725,2.38438 12.525,3.13503 11.4487,3.65219 10.3723,4.16936 9.19415,4.44001 8,4.44444 H 2.66667 C 1.95966,4.44522 1.28183,4.72642 0.781901,5.22635 0.281971,5.72628 7.71729e-4,6.4041 0,7.11111 V 8.88889 C 7.71729e-4,9.5959 0.281971,10.2737 0.781901,10.7737 1.28183,11.2736 1.95966,11.5548 2.66667,11.5556 H 3.0967 L 0.960942,16.539 c -0.05804,0.1352 -0.081604,0.2827 -0.068576,0.4292 0.013028,0.1465 0.06224,0.2875 0.143214,0.4103 0.08098,0.1228 0.19119,0.2236 0.32073,0.2933 0.12954,0.0697 0.27437,0.1061 0.42147,0.106 h 3.55555 c 0.17401,10e-5 0.3442,-0.051 0.48943,-0.1468 0.14523,-0.0958 0.25909,-0.2323 0.32742,-0.3923 l 2.42111,-5.6494 c 1.0939,0.0804 2.15971,0.3841 3.13171,0.8924 0.9719,0.5084 1.8293,1.2106 2.5192,2.0633 v 0.5661 c 0,0.2358 0.0937,0.4619 0.2604,0.6286 C 14.6493,15.9063 14.8754,16 15.1111,16 15.3469,16 15.5729,15.9063 15.7396,15.7397 15.9063,15.573 16,15.3469 16,15.1111 V 0.888889 C 16.0001,0.772139 15.9771,0.656521 15.9325,0.548646 15.8878,0.44077 15.8224,0.342753 15.7398,0.260199 15.6572,0.177644 15.5592,0.112172 15.4514,0.0675247 15.3435,0.0228779 15.2279,-6.76241e-5 15.1111,1.4969877e-7 Z M 2.66667,9.77778 C 2.43097,9.77762 2.20497,9.68392 2.0383,9.51725 1.87164,9.35059 1.77794,9.12459 1.77778,8.88889 V 7.11111 C 1.77794,6.87541 1.87164,6.64941 2.0383,6.48275 2.20497,6.31609 2.43097,6.22238 2.66667,6.22222 H 3.55555 V 9.77778 Z M 4.7474,16 H 3.12587 l 1.90451,-4.4444 h 1.62153 z m 9.4748,-3.9806 C 12.4696,10.5755 10.2708,9.78336 8,9.77773 H 5.33333 V 6.22218 H 8 C 10.2709,6.21637 12.4696,5.4241 14.2222,3.9801 Z"
            fill={currentColor}
            id="path833" />
          <path
            d="m 21.554143,7.4983477 h 1 c 0.26522,0 0.51957,0.10536 0.70711,0.29289 0.18754,0.1875397 0.29289,0.4418897 0.29289,0.7071097 0,0.26522 -0.10535,0.51957 -0.29289,0.70711 -0.18754,0.18753 -0.44189,0.29289 -0.70711,0.29289 h -1 c -2,0 0,0 -2,0 h -1 c -0.265216,0 -0.519571,-0.10536 -0.707107,-0.29289 -0.187537,-0.18754 -0.292893,-0.44189 -0.292893,-0.70711 0,-0.26522 0.105356,-0.51957 0.292893,-0.7071097 0.187536,-0.18753 0.441891,-0.29289 0.707107,-0.29289 h 1 c 2,0 0,0 2,0 z"
            fill={currentColor}
            id="path843-3" />
        </svg>
      )
    } else if (name === "usersPlus") {
      return (
        <svg
          style={currentStyle}
          xmlns="http://www.w3.org/2000/svg"
          id="svg1449"
          version="1.1"
          fill="none"
          viewBox="0 0 24.002707 14.681781"
          height={height === undefined ? "15" : height}
          width={width === undefined ? "24" : width}>
          <path
            id="path1447"
            fill={currentColor}
            d="m 9.77236,7.5309112 c 0.46144,-0.39889 0.83154,-0.89224 1.08524,-1.44657 0.2537,-0.55434 0.3849,-1.15668 0.3849,-1.76616 0,-1.14525 -0.4555,-2.2436 -1.26645,-3.05341 C 9.16514,0.45495016 8.0653,1.5503135e-7 6.91849,1.5503135e-7 5.77168,1.5503135e-7 4.67184,0.45495016 3.86092,1.2647712 c -0.81092,0.80981 -1.26649,1.90816 -1.26649,3.05341 0,0.60948 0.13128,1.21182 0.38495,1.76616 0.25367,0.55433 0.62379,1.04768 1.08523,1.44657 -1.21061,0.54744 -2.23773,1.4315 -2.95853,2.5464698 -0.720811,1.115 -1.10480712,2.4137 -1.10608,3.7408 0,0.2291 0.0911137,0.4487 0.253297,0.6107 0.162184,0.1619 0.382152,0.2529 0.611514,0.2529 0.229359,0 0.449329,-0.091 0.611509,-0.2529 0.16219,-0.162 0.2533,-0.3816 0.2533,-0.6107 0,-1.3743 0.54668,-2.6923 1.51978,-3.6641 0.97311,-0.9717798 2.29291,-1.5177198 3.66909,-1.5177198 1.37617,0 2.69598,0.54594 3.66911,1.5177198 0.9731,0.9718 1.5198,2.2898 1.5198,3.6641 0,0.2291 0.0911,0.4487 0.2532,0.6107 0.1622,0.1619 0.3822,0.2529 0.6116,0.2529 0.2293,0 0.4493,-0.091 0.6115,-0.2529 0.1622,-0.162 0.2533,-0.3816 0.2533,-0.6107 -0.0013,-1.3271 -0.3853,-2.6258 -1.1061,-3.7408 C 12.0101,8.9624112 10.983,8.0783512 9.77236,7.5309112 Z m -2.85387,-0.62182 c -0.51313,0 -1.01474,-0.15195 -1.44139,-0.43665 -0.42666,-0.28469 -0.75919,-0.68933 -0.95556,-1.16276 -0.19636,-0.47343 -0.24774,-0.99437 -0.14763,-1.49696 0.1001,-0.50259 0.3472,-0.96424 0.71004,-1.32659 0.36283,-0.36234 0.82512,-0.6091 1.32839,-0.70907 0.50327,-0.09998 1.02492,-0.04867 1.49899,0.14743 0.47407,0.1961 0.87927,0.52819 1.16435,0.95426 0.28508,0.42607 0.43724,0.927 0.43724,1.43943 0,0.68715 -0.27334,1.34616 -0.75989,1.83205 -0.48655,0.48589 -1.14646,0.75886 -1.83454,0.75886 z m 8.42321,0.27636 c 0.5535,-0.62239 0.915,-1.39127 1.0411,-2.21407 0.1261,-0.8228 0.0114,-1.66445 -0.3304,-2.42365 -0.3417,-0.7592 -0.8959,-1.40359 -1.5958,-1.85559004 C 13.7567,0.24013416 12.9409,-2.2284497e-4 12.1074,1.5503135e-7 11.878,1.5503135e-7 11.658,0.09099016 11.4958,0.25295316 c -0.1621,0.161963 -0.2533,0.381628 -0.2533,0.610688 0,0.22905004 0.0912,0.44872004 0.2533,0.61068004 0.1622,0.16196 0.3822,0.25295 0.6116,0.25295 0.688,0 1.3479,0.27297 1.8345,0.75886 0.4865,0.48589 0.7599,1.1449 0.7599,1.83205 -0.0012,0.45362 -0.1217,0.89896 -0.3493,1.2915 -0.2277,0.39254 -0.5546,0.71851 -0.9479,0.94532 -0.1283,0.07386 -0.2353,0.17935 -0.3111,0.30637 -0.0757,0.12702 -0.1175,0.27132 -0.1213,0.41908 -0.0037,0.14662 0.0302,0.29174 0.0983,0.42168 0.068,0.12994 0.1681,0.24043 0.2908,0.32105 l 0.3373,0.22455 0.1124,0.06045 c 1.0425,0.49376 1.9219,1.27472 2.5348,2.2508998 0.6128,0.9762 0.9336,2.107 0.9245,3.2591 0,0.2291 0.0911,0.4487 0.2533,0.6107 0.1622,0.1619 0.3821,0.2529 0.6115,0.2529 0.2293,0 0.4493,-0.091 0.6115,-0.2529 0.1622,-0.162 0.2533,-0.3816 0.2533,-0.6107 0.0071,-1.3253 -0.3253,-2.6304 -0.9656,-3.7913 C 17.394,8.8659812 16.4672,7.8878612 15.3417,7.1854512 Z" />
          <path
            d="m 22.002707,4.383993 h 1 c 0.26522,0 0.51957,0.10536 0.70711,0.29289 0.18754,0.18754 0.29289,0.44189 0.29289,0.70711 0,0.26522 -0.10535,0.51957 -0.29289,0.70711 -0.18754,0.18753 -0.44189,0.29289 -0.70711,0.29289 h -1 v 1 c 0,0.26522 -0.10535,0.51957 -0.29289,0.70711 -0.18754,0.18753 -0.44189,0.29289 -0.70711,0.29289 -0.26522,0 -0.51957,-0.10536 -0.70711,-0.29289 -0.18753,-0.18754 -0.29289,-0.44189 -0.29289,-0.70711 v -1 h -1 c -0.265216,0 -0.519571,-0.10536 -0.707107,-0.29289 -0.187537,-0.18754 -0.292893,-0.44189 -0.292893,-0.70711 0,-0.26522 0.105356,-0.51957 0.292893,-0.70711 0.187536,-0.18753 0.441891,-0.29289 0.707107,-0.29289 h 1 v -1 c 0,-0.265217 0.10536,-0.51957 0.29289,-0.707107 0.18754,-0.187536 0.44189,-0.292893 0.70711,-0.292893 0.26522,0 0.51957,0.105357 0.70711,0.292893 0.18754,0.187537 0.29289,0.44189 0.29289,0.707107 z"
            fill={currentColor}
            id="path843" />
        </svg>

      )
    } else if (name === "usersMinus") {
      return (
        <svg
          style={currentStyle}
          xmlns="http://www.w3.org/2000/svg"
          height={height === undefined ? "15" : height}
          width={width === undefined ? "24" : width}
          viewBox="0 0 24.002707 14.681781"
          fill="none"
          version="1.1"
          id="svg1449">
          <path
            d="m 9.77236,7.5309112 c 0.46144,-0.39889 0.83154,-0.89224 1.08524,-1.44657 0.2537,-0.55434 0.3849,-1.15668 0.3849,-1.76616 0,-1.14525 -0.4555,-2.2436 -1.26645,-3.05341 C 9.16514,0.45495016 8.0653,1.5503135e-7 6.91849,1.5503135e-7 5.77168,1.5503135e-7 4.67184,0.45495016 3.86092,1.2647712 c -0.81092,0.80981 -1.26649,1.90816 -1.26649,3.05341 0,0.60948 0.13128,1.21182 0.38495,1.76616 0.25367,0.55433 0.62379,1.04768 1.08523,1.44657 -1.21061,0.54744 -2.23773,1.4315 -2.95853,2.5464698 -0.720811,1.115 -1.10480712,2.4137 -1.10608,3.7408 0,0.2291 0.0911137,0.4487 0.253297,0.6107 0.162184,0.1619 0.382152,0.2529 0.611514,0.2529 0.229359,0 0.449329,-0.091 0.611509,-0.2529 0.16219,-0.162 0.2533,-0.3816 0.2533,-0.6107 0,-1.3743 0.54668,-2.6923 1.51978,-3.6641 0.97311,-0.9717798 2.29291,-1.5177198 3.66909,-1.5177198 1.37617,0 2.69598,0.54594 3.66911,1.5177198 0.9731,0.9718 1.5198,2.2898 1.5198,3.6641 0,0.2291 0.0911,0.4487 0.2532,0.6107 0.1622,0.1619 0.3822,0.2529 0.6116,0.2529 0.2293,0 0.4493,-0.091 0.6115,-0.2529 0.1622,-0.162 0.2533,-0.3816 0.2533,-0.6107 -0.0013,-1.3271 -0.3853,-2.6258 -1.1061,-3.7408 C 12.0101,8.9624112 10.983,8.0783512 9.77236,7.5309112 Z m -2.85387,-0.62182 c -0.51313,0 -1.01474,-0.15195 -1.44139,-0.43665 -0.42666,-0.28469 -0.75919,-0.68933 -0.95556,-1.16276 -0.19636,-0.47343 -0.24774,-0.99437 -0.14763,-1.49696 0.1001,-0.50259 0.3472,-0.96424 0.71004,-1.32659 0.36283,-0.36234 0.82512,-0.6091 1.32839,-0.70907 0.50327,-0.09998 1.02492,-0.04867 1.49899,0.14743 0.47407,0.1961 0.87927,0.52819 1.16435,0.95426 0.28508,0.42607 0.43724,0.927 0.43724,1.43943 0,0.68715 -0.27334,1.34616 -0.75989,1.83205 -0.48655,0.48589 -1.14646,0.75886 -1.83454,0.75886 z m 8.42321,0.27636 c 0.5535,-0.62239 0.915,-1.39127 1.0411,-2.21407 0.1261,-0.8228 0.0114,-1.66445 -0.3304,-2.42365 -0.3417,-0.7592 -0.8959,-1.40359 -1.5958,-1.85559004 C 13.7567,0.24013416 12.9409,-2.2284497e-4 12.1074,1.5503135e-7 11.878,1.5503135e-7 11.658,0.09099016 11.4958,0.25295316 c -0.1621,0.161963 -0.2533,0.381628 -0.2533,0.610688 0,0.22905004 0.0912,0.44872004 0.2533,0.61068004 0.1622,0.16196 0.3822,0.25295 0.6116,0.25295 0.688,0 1.3479,0.27297 1.8345,0.75886 0.4865,0.48589 0.7599,1.1449 0.7599,1.83205 -0.0012,0.45362 -0.1217,0.89896 -0.3493,1.2915 -0.2277,0.39254 -0.5546,0.71851 -0.9479,0.94532 -0.1283,0.07386 -0.2353,0.17935 -0.3111,0.30637 -0.0757,0.12702 -0.1175,0.27132 -0.1213,0.41908 -0.0037,0.14662 0.0302,0.29174 0.0983,0.42168 0.068,0.12994 0.1681,0.24043 0.2908,0.32105 l 0.3373,0.22455 0.1124,0.06045 c 1.0425,0.49376 1.9219,1.27472 2.5348,2.2508998 0.6128,0.9762 0.9336,2.107 0.9245,3.2591 0,0.2291 0.0911,0.4487 0.2533,0.6107 0.1622,0.1619 0.3821,0.2529 0.6115,0.2529 0.2293,0 0.4493,-0.091 0.6115,-0.2529 0.1622,-0.162 0.2533,-0.3816 0.2533,-0.6107 0.0071,-1.3253 -0.3253,-2.6304 -0.9656,-3.7913 C 17.394,8.8659812 16.4672,7.8878612 15.3417,7.1854512 Z"
            fill={currentColor}
            id="path1447" />
          <path
            id="path843"
            fill={currentColor}
            d="m 22.002707,4.383993 h 1 c 0.26522,0 0.51957,0.10536 0.70711,0.29289 0.18754,0.18754 0.29289,0.44189 0.29289,0.70711 0,0.26522 -0.10535,0.51957 -0.29289,0.70711 -0.18754,0.18753 -0.44189,0.29289 -0.70711,0.29289 h -1 c -2,0 0,0 -2,0 h -1 c -0.265216,0 -0.519571,-0.10536 -0.707107,-0.29289 -0.187537,-0.18754 -0.292893,-0.44189 -0.292893,-0.70711 0,-0.26522 0.105356,-0.51957 0.292893,-0.70711 0.187536,-0.18753 0.441891,-0.29289 0.707107,-0.29289 h 1 c 2,0 0,0 2,0 z" />
        </svg>

      )
    } else if (name === "download") {
      return (
        <svg
          style={currentStyle}
          xmlns="http://www.w3.org/2000/svg"
          id="svg3195"
          version="1.1"
          fill="none"
          viewBox="0 0 20 20.770023"
          height={height === undefined ? "20" : height}
          width={width === undefined ? "20" : width}>
          <path
            id="path3193"
            strokeLinejoin="round"
            strokeLinecap="round"
            strokeWidth="2"
            stroke={currentColor}
            d="m 19,13.770023 v 4 c 0,0.53043 -0.2107,1.03914 -0.5858,1.41421 -0.3751,0.37508 -0.8838,0.58579 -1.4142,0.58579 H 3 c -0.53043,0 -1.03914,-0.21071 -1.41421,-0.58579 C 1.21071,18.809163 1,18.300453 1,17.770023 v -4" />
          <path
            d="M 10,13 V 1"
            stroke={currentColor}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            id="path2622" />
          <path
            d="M 4.9999999,7.9999997 10,13 15,7.9999997"
            stroke={currentColor}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            id="path2051" />
        </svg>
      )
    } else if (name === "plus") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="svg4999"
          version="1.1"
          fill="none"
          viewBox="0 0 16 16"
          style={currentStyle}
          height={height === undefined ? "16" : height}
          width={width === undefined ? "16" : width}>
          <path
            id="path4997"
            strokeLinejoin="round"
            strokeLinecap="round"
            strokeWidth="2"
            stroke={currentColor}
            d="M 1,8 H 15" />
          <path
            d="M 8,1 V 15"
            stroke={currentColor}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            id="path5568" />
        </svg>
      )
    } else if (name === "video") {
      return (
        <svg
          height={height === undefined ? "16" : height}
          width={width === undefined ? "23.5" : width}
          version="1.1" viewBox="0 0 6.0861 4.3555" xmlns="http://www.w3.org/2000/svg">
          <g transform="translate(-8.4554 -84.061)" fill="none" stroke={currentColor}>
            <g transform="matrix(.26458 0 0 .26458 8.3235 83.664)" strokeWidth="1.8">
              <path d="m22.54 4.42c-0.1188-0.47459-0.3607-0.90943-0.7013-1.2606-0.3407-0.35117-0.7679-0.60622-1.2387-0.73941-1.72-0.42-8.6-0.42-8.6-0.42s-6.88 0-8.6 0.46c-0.47075 0.13319-0.89802 0.38824-1.2386 0.73941-0.34063 0.35116-0.58256 0.786-0.70135 1.2606-0.31478 1.7456-0.46876 3.5163-0.46 5.29-0.011218 1.787 0.14277 3.5713 0.46 5.33 0.13096 0.4598 0.37831 0.8781 0.71815 1.2145 0.33983 0.3363 0.76067 0.5793 1.2218 0.7055 1.72 0.46 8.6 0.46 8.6 0.46s6.88 0 8.6-0.46c0.4708-0.1332 0.898-0.3882 1.2387-0.7394 0.3406-0.3512 0.5825-0.786 0.7013-1.2606 0.3124-1.7324 0.4663-3.4897 0.46-5.25 0.0112-1.787-0.1427-3.5713-0.46-5.33z" fill="none" stroke={currentColor} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
            </g>
            <g transform="matrix(.26458 0 0 .26458 10.385 84.982)" strokeWidth="1.8">
              <path d="m1.75 8.02 5.75-3.27-5.75-3.27z" stroke={currentColor} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
            </g>
          </g>
        </svg>
      )
    } else if (name === "calendar") {
      return (
        <svg
          height={height === undefined ? "26" : height}
          width={width === undefined ? "28" : width}
          fill="none" version="1.1" viewBox="0 0 20.081 22.081" xmlns="http://www.w3.org/2000/svg">
          <path d="m17.041 3.0406h-14c-1.1046 0-2 0.89543-2 2v14c0 1.1046 0.89543 2 2 2h14c1.1046 0 2-0.8954 2-2v-14c0-1.1046-0.8954-2-2-2z" stroke={currentColor} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.0812" />
          <g stroke={currentColor} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.0812">
            <path d="m1.0406 9.0406h18" />
            <path d="m14.041 1.0406v4" />
            <path d="m6.0411 1.0406v4" />
          </g>
        </svg>
      )
    } else if (name === "bars") {
      return (
        <svg
          height={height === undefined ? "24" : height}
          width={width === undefined ? "24" : width}
          xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke={currentColor} className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12" />
        </svg>

      )
    } else if (name === "person") {
      return (
        <svg
          height={height === undefined ? "24" : height}
          width={width === undefined ? "15" : width}
          xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15.002454 24" strokeWidth={1.5} stroke={currentColor} className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="m 5.248883,2.2500007 a 2.2500007,2.2500007 0 1 1 4.5000015,0 2.2500008,2.2500008 0 1 1 -4.5000015,0 z M 7.123885,16.5 v 5.999999 C 7.123885,23.329686 6.4535715,24 5.6238845,24 4.7941974,24 4.123884,23.329686 4.123884,22.499999 V 12.042188 L 2.7832598,14.273437 C 2.356696,14.981248 1.43326,15.210936 0.72544638,14.784375 0.01763279,14.357811 -0.21205459,13.434375 0.21450924,12.726561 L 2.9473226,8.1796863 C 3.7629474,6.8249998 5.2254451,5.9953128 6.8051324,5.9953128 h 1.3921892 c 1.5796873,0 3.0421874,0.829687 3.8578124,2.1843735 l 2.732811,4.5468747 c 0.426564,0.707814 0.196876,1.63125 -0.510937,2.057814 -0.707811,0.426561 -1.63125,0.196873 -2.057811,-0.510938 L 10.873883,12.042188 V 22.499999 C 10.873883,23.329686 10.20357,24 9.373883,24 8.544196,24 7.8738825,23.329686 7.8738825,22.499999 V 16.5 Z" />
        </svg>
      )
    } else if (name === "bell") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={height === undefined ? "23" : height}
          width={width === undefined ? "20" : width}
          viewBox="0 0 448 512" fill={currentColor}>
          <path d="M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z" />
        </svg>
      )
    } else if (name === "cancel") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={height === undefined ? "24" : height}
          width={width === undefined ? "24" : width}
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={currentColor}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    } else if (name === "archive") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={height === undefined ? "24" : height}
          width={width === undefined ? "24" : width}
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={currentColor}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m6 4.125l2.25 2.25m0 0l2.25 2.25M12 13.875l2.25-2.25M12 13.875l-2.25 2.25M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
        </svg>
      )
    } else if (name === "clock") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={height === undefined ? "24" : height}
          width={width === undefined ? "24" : width}
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke={currentColor}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    } else if (name === "library") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={height === undefined ? "24" : height}
          width={width === undefined ? "24" : width}
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={currentColor}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z" />
        </svg>
      )
    } else if (name === "user-circle") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={height === undefined ? "24" : height}
          width={width === undefined ? "24" : width}
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={currentColor}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        </svg>

      )
    } else if (name === "share") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={height === undefined ? "24" : height}
          width={width === undefined ? "24" : width}
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={currentColor}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z" />
        </svg>
      )
    } else if (name === "tag") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={height === undefined ? "24" : height}
          width={width === undefined ? "24" : width}
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={currentColor}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 6h.008v.008H6V6Z" />
        </svg>
      )
    } else if (name === "info") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height={height === undefined ? "24" : height}
          width={width === undefined ? "24" : width}
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={currentColor}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
        </svg>
      )
    }
    return null
  }

  if (raw) {
    return renderIcon(hovering ? colorHover : color, style)
  } else {
    return (
      <View style={[styles.iconWrapper, style, onClick === undefined ? {} : { cursor: 'pointer' }]} onClick={onClick} onMouseEnter={onHover} onMouseLeave={onHoverOut}>
        {renderIcon(hovering ? colorHover : color)}
      </View>
    )
  }
}

const styles = StyleSheet.create({
  iconWrapper: {
  }
});

const cssStyles = {
}
